module.exports = __webpack_public_path__ + "assets/003-slides.412a5d2c.svg";